import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowStepTagsIcon from './FlowStepTagsIcon';

const FlowStepTagsIconBridge = react2angular(FlowStepTagsIcon, [
  'stepName',
  'stepTagIds'
]);
export default FlowStepTagsIconBridge;
